import React from "react";
import "./Registration.scss";

// Types
import { User } from "../../../types";

// Services
import { ApiService } from "../../../services";

// Components
import { IonCol, IonContent, IonRow, IonSegment, IonSegmentButton, withIonLifeCycle } from "@ionic/react";
import Admin from "../../../components/Admin";
import { AdminTemplate } from "../../../components/PageTemplates";
import StageCard from "./StageCard/StageCard";

// Font Awesome
import { IconName } from "@fortawesome/fontawesome-common-types";
import { faGear, faUsers } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation } from "react-i18next";
import { debug } from "../../../App";

interface RegistrationState {
  loading: boolean;
  view: "grid" | "columns";
  columns: { [key: string]: Column };
  segment: string;
}

interface Column {
  name: string;
  active: boolean;
  icon: IconName | IconName[];
  iconColour?: string;
  users: User[];
  viewAllParams: { [key: string]: string };
}

class Registration extends React.Component<any, RegistrationState | any> {
  protected slides: React.RefObject<HTMLIonSlidesElement>;

  constructor(props: Readonly<any> | RegistrationState | any) {
    super(props);

    this.state = {
      loading: true,
      segment: "users",
      columns: {
        outstanding: { name: "Outstanding Requests", active: true, icon: "bell", users: [], viewAllParams: { "filters[pending_revisions]": "1" } },
        active: { name: "Active", active: false, icon: "circle-check", users: [], viewAllParams: { "filters[status]": "active" } },
        declined: { name: "Declined", active: false, icon: "circle-xmark", users: [], viewAllParams: { "filters[status]": "declined" } },
        blocked: { name: "Blocked", active: false, icon: "lock", users: [], viewAllParams: { "filters[status]": "blocked" } },
        cancelled: { name: "Cancelled", active: false, icon: "trash-alt", users: [], viewAllParams: { "filters[status]": "cancelled" } },
      },
    };

    this.slides = React.createRef();
  }

  render() {
    const { columns, segment }: Readonly<RegistrationState> = this.state;
    const { t } = this.props;

    return (
      <AdminTemplate className="page--admin page--admin--register page--has-sidebar">
        <IonContent>
          <div className="page--has-sidebar__layout">
            <div>
              <div className="wrapper ion-padding-vertical">
                <IonRow className="ion-margin-end ion-margin-top ion-align-items-center">
                  <IonCol size="12">
                    <h1>{t("registration")}</h1>
                  </IonCol>
                </IonRow>

                <IonSegment className="registration-segment ion-hide-lg-up" value={segment} mode="md" onIonChange={(e) => this.setState({ segment: e.detail.value })}>
                  <IonSegmentButton value="users" layout="icon-start" className="registration-segment__button">
                    <FontAwesomeIcon icon={faUsers} />
                    <span>{t("users")}</span>
                  </IonSegmentButton>
                  <IonSegmentButton value="forms" layout="icon-start" className="registration-segment__button">
                    <FontAwesomeIcon icon={faGear} />
                    <span>{t("forms")}</span>
                  </IonSegmentButton>
                </IonSegment>

                <div className="registration-stages registration-stages--grid">
                  {segment === "users" ? (
                    Object.values(columns).map((column, key: number) => <StageCard stage={column} key={key} loading={this.state.loading} />)
                  ) : (
                    <Admin.Registration.Sidebar className="sidebar--mobile" />
                  )}
                </div>
              </div>
            </div>
            <Admin.Registration.Sidebar className="ion-hide-lg-down" />
          </div>
        </IonContent>
      </AdminTemplate>
    );
  }

  componentDidMount() {
    const { t } = this.props;

    Promise.all([this.getUsers()])
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.error(err);
        alert(t("loadingUsersErrors"));
      });
  }

  getUsers = async () => {
    const { t } = this.props;

    return ApiService.get("users", { groupBy: "stage" })
      .then((groups) => {
        const { columns } = this.state;

        Object.keys(groups).forEach((key) => {
          if (groups.hasOwnProperty(key)) {
            if (columns.hasOwnProperty(key)) {
              columns[key].users = groups[key];
            } else {
              console.warn(`Trying to add users to column "${key}" which does not exist.`);
            }
          } else {
            debug(`${t("missing")} ${key}.`);
          }
        });

        this.setState({ columns });

        return groups;
      })
      .catch((err) => alert(err.message));
  };
}

const firstHoc = withIonLifeCycle(Registration);
export default withTranslation()(firstHoc);
